const prefixCls = 'web.app.';
export const localesApp = {
  [prefixCls + 'title']: {
    zh_CN: '极速卖家', // 您的中文应用标题
    en_GB: 'Speedy Seller', // 您的英文应用标题
  },
};
